(function(){
     const openHambage = document.querySelector('.icon-hamburger');
    const span = openHambage.parentElement;
    const announcementBar = document.querySelector('.shopify-section-announcement-bar');
    const headericonAccount = document.querySelector('.header__icon--account');
    const headericonCart = document.querySelector('.header__icon--cart');
    const headerLogo = document.querySelector('.header__heading');
    let clickCount = 0;
    const firstBtntitle = document.querySelectorAll('.first-btn-title');
    const secondBtnmenu = document.querySelectorAll('.second-btn-menu');
    const returnfsBtn = document.querySelectorAll('.nav-second-menu svg');
    const hamberBtn = document.querySelector('.hamburgermain');
    const hamberBtnChildone = document.querySelector('.hamburgermain .hm-child__one');
    const hamberBtnChildtwo = document.querySelector('.hamburgermain .hm-child__two');
    const hamberBtnChildthree = document.querySelector('.hamburgermain .hm-child__three');
    const detailsElements = document.querySelectorAll('.third-grand-titledt');
    const thirdGrandtitle = document.querySelectorAll('.third-grand-title');

    document.addEventListener('DOMContentLoaded', function() {

      if(announcementBar){
        function updateAnnouncementBarScrollHeight() {
          const announcementBarHeight = announcementBar.offsetHeight;
          const scrollDistance = window.scrollY;
          
          if (scrollDistance >= announcementBarHeight) {
            document.documentElement.style.setProperty('--announcement-bar-scroll-height', '0px');
          } else {
            const remainingHeight = announcementBarHeight - scrollDistance;
            document.documentElement.style.setProperty('--announcement-bar-scroll-height', remainingHeight + 'px');
          }
        }
        updateAnnouncementBarScrollHeight();
        window.addEventListener('scroll', updateAnnouncementBarScrollHeight);
      }

      
      span.addEventListener('click', function() {
        clickCount++;
        if (clickCount % 2 === 1) {
          document.body.classList.add('mobile-menu-open');
          announcementBar.style.display = 'none';
          headericonAccount.style.opacity = '0';
          headericonCart.style.opacity = '0';
          headerLogo.style.opacity = '0';
          // document.querySelector("#Details-menu-drawer-container").open = true;
          // hamberBtnChildone.style.transform = 'translateY(2px) rotate(45deg)';
          // hamberBtnChildtwo.style.opacity = '0';
          // hamberBtnChildthree.style.transform = 'translateY(-8px) rotate(-45deg)';
        } else {
          announcementBar.style.display = 'block';
          headericonAccount.style.opacity = '1';
          headericonCart.style.opacity = '1';
          headerLogo.style.opacity = '1';
          // hamberBtnChildone.style.transform = 'unset';
          // hamberBtnChildtwo.style.opacity = '1';
          // hamberBtnChildthree.style.transform = 'unset';
          firstBtntitle.forEach((btn,index) => {
            secondBtnmenu[index].style.left = '100vw';
            secondBtnmenu[index].classList.remove("open");
          });
        }
      });

      firstBtntitle.forEach((btn,index) => {
        btn.addEventListener('click', function() {
          secondBtnmenu.forEach((menu) => {
            menu.style.opacity = '0';
            menu.style.left = '100vw';
            menu.style.transition = 'all 0.7s';
            menu.classList.remove("open");
            
          });
          secondBtnmenu[index].style.transition = 'all 0.7s';
          secondBtnmenu[index].style.opacity = '1';
          secondBtnmenu[index].style.left = '0vw';
          secondBtnmenu[index].classList.add("open");

                const productElements = secondBtnmenu[index].querySelectorAll('.second-menu__collection');
                const seenIds = new Set();
          
                productElements.forEach((element) => {
                  const productId = element.getAttribute('data-proid');
                  if (seenIds.has(productId)) {
                    element.style.display = 'none';
                  } else {
                    seenIds.add(productId);
                  }
                });
          
        });
      });

      returnfsBtn.forEach((btn,index) => {
        btn.addEventListener('click', function() {
          secondBtnmenu[index].style.left = '100vw';
            secondBtnmenu[index].classList.remove("open");
        });
      });

    const detailsElements = document.querySelectorAll('.third-grand-titledt');
      /*
    detailsElements.forEach(details => {
      details.addEventListener('toggle', function () {
        if (this.open) {
          console.log('Opended');
          detailsElements.forEach(otherDetails => {
            if (otherDetails !== this && otherDetails.open) {
              otherDetails.removeAttribute('open');
              otherDetails.style.transition = 'all 0.8s';
              otherDetails.querySelector('summary').setAttribute('aria-expanded', 'false');
            }
          });
          this.querySelector('summary').setAttribute('aria-expanded', 'true');
        } else {
          this.querySelector('summary').setAttribute('aria-expanded', 'false');
        }
      });
    });*/

  detailsElements.forEach(details => {
  const summary = details.querySelector('summary');
  summary.setAttribute('aria-expanded', details.hasAttribute('open'));

  details.addEventListener('toggle', function () {
    const isOpen = this.hasAttribute('open');
    const summary = this.querySelector('summary');
    
    if (isOpen) {
      detailsElements.forEach(otherDetails => {
        if (otherDetails !== this && otherDetails.hasAttribute('open')) {
          otherDetails.removeAttribute('open');
          otherDetails.querySelector('summary').setAttribute('aria-expanded', 'false');
        }
      });
      summary.setAttribute('aria-expanded', 'true');
    } else {
      summary.setAttribute('aria-expanded', 'false');
    }
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const firstDetails = detailsElements[0];
  if (firstDetails && firstDetails.hasAttribute('open')) {
    firstDetails.querySelector('summary').setAttribute('aria-expanded', 'true');
  }
});
      

    });
})()